import React, { Component } from 'react';
import {browserHistory} from 'react-router';
import LocalizedStrings from '../../localization/strings';

function getCurrentPrice(prices) {
    if (!prices || prices.length === 0) return null;
    const now = new Date();
    const sorted = [...prices].sort((a, b) => new Date(a.price_until_date) - new Date(b.price_until_date));
    for (const tier of sorted) {
        if (now < new Date(tier.price_until_date)) {
            return tier.price;
        }
    }
    return sorted[sorted.length - 1].price;
}

function DistanceCard({ distance, onRegister }) {
    const price = getCurrentPrice(distance.prices);
    const isFull = distance.is_full;
    const availableSpots = distance.available_spots;

    const statusText = isFull
        ? LocalizedStrings.distanceFull
        : distance.isFree
            ? LocalizedStrings.isFree
            : null;

    const statusClass = isFull
        ? 'distance-card__status--full'
        : availableSpots != null && availableSpots < 30
            ? 'distance-card__status--low'
            : '';

    return (
        <div className={`distance-card${isFull ? ' distance-card--full' : ''}`}>
            <div className="distance-card__left">
                <span className="distance-card__badge">
                    {distance.is_team_distance ? LocalizedStrings.team : LocalizedStrings.solo}
                </span>
                <div className="distance-card__name">{distance.name}</div>
            </div>

            <div className="distance-card__status-col">
                {!isFull && !distance.isFree && price != null && (
                    <span className="distance-card__price">{LocalizedStrings.priceFrom}: {price}</span>
                )}
                {statusText && (
                  <span className={`distance-card__status ${statusClass}`}>{statusText}</span>
                )}
                {!isFull && availableSpots != null && (
                    <span className={`distance-card__spots${availableSpots < 30 ? ' distance-card__spots--low' : ''}`}>
                         {LocalizedStrings.spotsAvailable}: {availableSpots}
                    </span>
                )}
            </div>

            <div className="distance-card__action">
                <button
                    className="distance-card__register-btn"
                    disabled={isFull}
                    onClick={() => onRegister(distance)}
                >
                    <span className="distance-card__register-text">{LocalizedStrings.register}</span>
                    <span className="distance-card__register-icon">
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                            <path d="M17 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-11 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-1.45-3h12.9l1.88-9H3.12L1.68 3H0V1h3l.75 3H21l-2.26 11H4.55z"/>
                        </svg>
                    </span>
                </button>
            </div>
        </div>
    );
}

class DistanceList extends Component {
    constructor(props) {
        super(props);
        this.state = { distances: null, loading: true, error: false };
    }

    componentDidMount() {
        const { stageId } = this.props;
        fetch(`/api/stages/${stageId}/distances`)
            .then(r => r.json())
            .then(data => this.setState({ distances: data, loading: false }))
            .catch(() => this.setState({ loading: false, error: true }));
    }

    render() {
        const { stageId, onRegister } = this.props;
        const { distances, loading, error } = this.state;

        if (loading) return null;
        if (error || !distances || distances.length === 0) {
            return <p>{LocalizedStrings.noDistances}</p>;
        }

        const handleRegister = (distance) => {
            browserHistory.push(`/stages/${stageId}/registration/${distance.id}`);
            if (onRegister) onRegister(distance);
        };

        return (
            <div className="distance-list">
                {distances.map(distance => (
                    <DistanceCard
                        key={distance.id}
                        distance={distance}
                        onRegister={handleRegister}
                    />
                ))}
            </div>
        );
    }
}

export default DistanceList;



// WEBPACK FOOTER //
// ./src/js/components/stage/distance-list.js